// Recovered compiled webpack factory 28731. Edit this function expression; run npm run build.
(e, t, n) => {
  "use strict";
  (n.r(t), n.d(t, { default: () => s }));
  var r = n(95155),
    o = n(27122),
    l = n(56696),
    d = n.n(l),
    i = n(12115);
  function s(e) {
    let { error: t } = e;
    return (
      (0, i.useEffect)(() => {
        o.Cp(t);
      }, [t]),
      (0, r.jsx)("html", {
        lang: "en",
        children: (0, r.jsx)("body", { children: (0, r.jsx)(d(), { statusCode: 0 }) }),
      })
    );
  }
}
